
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import logoWhite from "@/assets/logo-white.png";
import logoOrange from "@/assets/logo-orange.png";

interface LogoProps {
  variant?: "default" | "white" | "orange";
}

const Logo = ({ variant = "default" }: LogoProps) => {
  // "default" and "orange" both use the transparent orange wordmark. (The old
  // default was an orange logo baked onto a white background, hidden via
  // mix-blend-multiply — which breaks on non-white grounds like the cream
  // stylist page, leaving a visible white box. The transparent PNG needs no hack.)
  const logoSrc = variant === "white" ? logoWhite : logoOrange;

  return (
    <Link to="/" className="flex items-center gap-2 hover:opacity-90 transition-opacity duration-200">
      <motion.div
        initial={{ scale: 0.9 }}
        animate={{ scale: 1 }}
        whileHover={{ scale: 1.05, rotate: [0, -2, 2, 0] }}
        transition={{ duration: 0.5 }}
        className="h-14 md:h-20 w-auto"
      >
        <img
          src={logoSrc}
          alt="Cello Logo"
          className="h-14 md:h-20 w-auto"
        />
      </motion.div>
    </Link>
  );
};

export default Logo;
